import {
    Button,
    Input,
    InputPassword,
    Form,
    FormItem,
    Select,
    Cascader,
    TreeSelect,
    RangePicker,
    DatePicker,
    InputNumber,
    Modal,
    ConfigProvider,
    Spin,
    Layout,
    LayoutHeader,
    Breadcrumb,
    Popover,
    Avatar,
    LayoutSider,
    Menu,
    MenuItem,
    LayoutContent,
    message,
    Table,
    Empty,
    Switch,
    SubMenu,
    Drawer,
    FormItemRest,
    Image,
    SelectOption,
    Upload,
    Pagination,
    Tooltip,
    CheckboxGroup,
    Checkbox,
    Radio,
    RadioGroup,
    Textarea,
    UploadDragger,
    TimePicker,
    Descriptions,
    DescriptionsItem,
    TabPane,
    Tabs
} from "ant-design-vue";

export default {
    install(app) {
        app.config.globalProperties.$message = message
        app.config.globalProperties.$modal = Modal
        app.component(FormItem.name,FormItem)
        app.component(TimePicker.name,TimePicker)
        app.component(Form.name,Form)
        app.component(Button.name,Button)
        app.component(Input.name,Input)
        app.component(InputPassword.name,InputPassword)
        app.component(Select.name,Select)
        app.component(Cascader.name,Cascader)
        app.component(TreeSelect.name,TreeSelect)
        app.component(RangePicker.name,RangePicker)
        app.component(DatePicker.name,DatePicker)
        app.component(InputNumber.name,InputNumber)
        app.component(Modal.name,Modal)
        app.component(ConfigProvider.name,ConfigProvider)
        app.component(Spin.name,Spin)
        app.component(Layout.name,Layout)
        app.component(LayoutHeader.name,LayoutHeader)
        app.component(Breadcrumb.name,Breadcrumb)
        app.component(Avatar.name,Avatar)
        app.component(Popover.name,Popover)
        app.component(LayoutSider.name,LayoutSider)
        app.component(Menu.name,Menu)
        app.component(MenuItem.name,MenuItem)
        app.component(LayoutContent.name,LayoutContent)
        app.component(Table.name,Table)
        app.component('AEmpty',Empty)
        app.component(Switch.name,Switch)
        app.component(SubMenu.name,SubMenu)
        app.component(Drawer.name,Drawer)
        app.component(FormItemRest.name,FormItemRest)
        app.component(Image.name,Image)
        app.component(Pagination.name,Pagination)
        app.component(Tooltip.name,Tooltip)
        app.component(Upload.name,Upload)
        app.component('ASelectOption',SelectOption)
        app.component(CheckboxGroup.name,CheckboxGroup)
        app.component(Checkbox.name,Checkbox)
        app.component(Radio.name,Radio)
        app.component(RadioGroup.name,RadioGroup)
        app.component(Textarea.name,Textarea)
        app.component(UploadDragger.name,UploadDragger)
        app.component(Descriptions.name,Descriptions)
        app.component(DescriptionsItem.name,DescriptionsItem)
        app.component(TabPane.name,TabPane)
        app.component(Tabs.name,Tabs)
    }
}